"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("./phoneStyles.scss");
var ru_json_1 = __importDefault(require("react-phone-input-2/lang/ru.json"));
var de_json_1 = __importDefault(require("react-phone-input-2/lang/de.json"));
var es_json_1 = __importDefault(require("react-phone-input-2/lang/es.json"));
var fr_json_1 = __importDefault(require("react-phone-input-2/lang/fr.json"));
var it_json_1 = __importDefault(require("react-phone-input-2/lang/it.json"));
var pl_json_1 = __importDefault(require("react-phone-input-2/lang/pl.json"));
var next_intl_1 = require("next-intl");
var react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
require("react-phone-input-2/lib/style.css");
var react_final_form_1 = require("react-final-form");
var AcceptPolicy_1 = __importDefault(require("./AcceptPolicy"));
var ui_components_1 = require("@l2p/ui-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var availableLanguages = {
    ru: ru_json_1.default,
    de: de_json_1.default,
    es: es_json_1.default,
    fr: fr_json_1.default,
    it: it_json_1.default,
    pl: pl_json_1.default,
};
var AddPhone = function () {
    var _a, _b, _c, _d;
    var lang = (0, next_intl_1.useLocale)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useUser)().data;
    var _e = (0, swr_hooks_1.useUpdateProfileData)({}), updateProfile = _e.updateProfile, isSubmitting = _e.isSubmitting;
    var initialValues = (0, react_1.useMemo)(function () { var _a, _b, _c, _d; return ({ phone: (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d.phone }); }, [(_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d.phone]);
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        if ((values === null || values === void 0 ? void 0 : values.phone) && (values === null || values === void 0 ? void 0 : values.phone) !== '') {
            updateProfile({ phone: values.phone });
        }
    }, [updateProfile]);
    var onRemovePhoneHandler = (0, react_1.useCallback)(function () {
        updateProfile({ phone: undefined });
    }, [updateProfile]);
    return (react_1.default.createElement("div", { className: "phone-wrapper ".concat((initialValues === null || initialValues === void 0 ? void 0 : initialValues.phone) ? 'set' : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('addVerifiedPhone')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.secondaryTitle }, t('verificationCodeWillSendSMS')),
            react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, initialValues: initialValues, render: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting, modified = _a.modified, values = _a.values;
                    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.formContainer },
                            react_1.default.createElement(react_final_form_1.Field, { name: "phone", render: function (_a) {
                                    var _b, _c, _d, _e, _f;
                                    var input = _a.input;
                                    return (react_1.default.createElement(react_phone_input_2_1.default, __assign({ country: ((_f = (_e = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.country) === null || _f === void 0 ? void 0 : _f.toLowerCase()) ||
                                            'us', disabled: Boolean(initialValues === null || initialValues === void 0 ? void 0 : initialValues.phone), localization: availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages[lang] }, input)));
                                } }),
                            (initialValues === null || initialValues === void 0 ? void 0 : initialValues.phone) ? (react_1.default.createElement(ui_components_1.FixedButton, { type: "button", loading: isSubmitting, height: "36px", maxWidth: "100%", variant: "outline", onClick: onRemovePhoneHandler }, t('remove'))) : (react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", disabled: !values.phone, loading: isSubmitting || submitting, height: "36px", maxWidth: "100%" }, t('add'))))));
                } }),
            react_1.default.createElement(AcceptPolicy_1.default, null))));
};
exports.default = AddPhone;
